import type { SensemakerCardStatus } from '@brushfire/types'

export const SENSEMAKER_STATUS_LABEL: Record<SensemakerCardStatus, string> = {
  active: 'Active',
  deactivated: 'Deactivated',
  expired: 'Expired',
}

export const SENSEMAKER_STATUS_COLORS: Record<
  SensemakerCardStatus,
  { bg: string; border: string; color: string }
> = {
  active: { bg: '#d1fae5', border: '#10b981', color: '#065f46' },
  deactivated: { bg: '#fae3ed', border: '#ff5959', color: '#ff5959' },
  expired: { bg: '#fffbeb', border: '#fee685', color: '#bb4d00' },
}
